import util from '@/tools/commonUtil'
const validQuLogics = function (question, logic, quItem, toQuItem, value, anQuItemId) {
  let isShow = true
  const { chooseType, logicType } = logic
  if ([1, 'question'].includes(logicType) || [2, 'clientProperty'].includes(logicType)) {
    isShow = commonValidLogic(chooseType, value, anQuItemId)
    if (!isShow) {
      return isShow
    }
  } else if (logicType === '3' || logicType === '4') {
    if (!commonValidLogic(chooseType, value, anQuItemId)) {
      this.setLogicValue(logic, toQuItem)
    }
  }
  return isShow
}
const getQuBeforLogicsExpress = function (logic, quItem, value, anQuItemId) {
  let resultStr = ''
  const { chooseType } = logic
  resultStr = !commonValidLogic(chooseType, value, anQuItemId)
  return resultStr
}

const commonValidLogic = (chooseType, value, anQuItemId) => {
  let isShow = true
  if (chooseType === '1') {
    if (util.isInArr(value, anQuItemId)) {
      isShow = false
      return false
    }
  } else if (chooseType === '2') {
    if (util.isContainsArr(value, anQuItemId)) {
      isShow = false
      return false
    }
  } else if (chooseType === '3') {
    if (!util.isContainsArr(value, anQuItemId)) {
      isShow = false
      return false
    }
  }
  return isShow
}

const logic = {
  validQuLogics,
  getQuBeforLogicsExpress,
  commonValidLogic
}

export default logic



// WEBPACK FOOTER //
// ./src/components/editor/CheckBoxGroup/logic.js